<div class="content">

    <div class="header">{{ 'bikeshop.shop_profile.collections.delivery_vehicles' | translate }}</div>

    <div class="row margin-top-16">
        <div class="col-md-4 label"
             [ngClass]="{invalid: !data.name}">{{ 'bikeshop.shop_profile.collections.name' | translate }}</div>
        <div class="col-md-8">
            <input type="text" pInputText [(ngModel)]="data.name"/>
        </div>
    </div>

    <div class="row margin-top-16">
        <div class="col-md-4 label"
             [ngClass]="{invalid: !data.maxBikes || data.maxBikes <= 0}">{{ 'bikeshop.shop_profile.collections.max_bikes' | translate }}</div>
        <div class="col-md-2">
            <input type="number" pInputText [(ngModel)]="data.maxBikes" min="1" max="50"/>
        </div>
    </div>

</div>

<!-- <div class="content">
  <div class="row margin-top-16">
    <div class="col-md-4 label" style="margin-top: 0px;" [ngClass]="{invalid: !selectedPartners || selectedPartners.length === 0}">{{ 'bikeshop.shop_profile.collections.link_to_stores' | translate }}</div>
    <div class="col-md-4 partners">
      <div *ngFor="let partner of linkedPartners">
        <div>
          <p-checkbox name="linkedPartners" value="{{partner.partnerID}}" [(ngModel)]="selectedPartners" [disabled]="linkedPartners.length === 1"></p-checkbox>
        </div>
        <div class="label">{{partner.partnerName}}</div>
      </div>
    </div>
  </div>
</div> -->

<div class="content">
    <div class="row">
        <div class="col-md-4 label" style="margin-top: 0px;"
             [ngClass]="{invalid: !selectedAreas || selectedAreas.length === 0}">{{
            'bikeshop.shop_profile.collections.linked_areas' | translate }}</div>
        <div class="col-md-4 partners">
            <div *ngFor="let area of areas">
                <div>
                    <p-checkbox name="linkedAreas" value="{{area.id}}" [(ngModel)]="selectedAreas"></p-checkbox>
                </div>
                <div class="label">{{area.areaName}}</div>
            </div>
        </div>
    </div>
</div>

<div class="content">
    <div class="row margin-bottom-16" *ngIf="!valid()">
        <div class="col-md-12 invalid">{{ 'bikeshop.shop_profile.collections.validation_message' | translate }}</div>
    </div>

    <div class="row">
        <div class="col-md-8 label"></div>
        <div class="col-md-4">
            <button pButton (click)="save()" class="p-button-raised full-width p-mini" [ngClass]="{'busy': saving}"
                    label="{{ (saving ? 'bikeshop.general.busy' : data.id ? 'bikeshop.general.update' : 'bikeshop.general.save') | translate}}"
                    [disabled]="saving || !valid()"></button>
        </div>
    </div>
</div>
